import * as yup from 'yup';

export const MoreDetailDialogSchema = yup.object().shape({
  loanPurpose: yup.string().required('* Mandatory field'),
  program: yup.string().required('* Mandatory field'),
  dealer: yup.string().required('* Mandatory field'),
  manager: yup.string().required('* Mandatory field'),
  dealerSalesReference: yup.string().required('* Mandatory field'),
});
